import * as type from '../../../actions/index.types'

const initialState = {
    // List
    invoicesData: [],
    invoicesPagination: null,
    loading: false,
    error: null,

    // Details
    invoiceDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Statistics
    statistics: null,
    statisticsLoading: false,
    statisticsError: null,

    // Invoices by Flat
    invoicesByFlat: [],
    invoicesByFlatLoading: false,
    invoicesByFlatError: null,

    // Unpaid Invoices by Flat
    unpaidInvoicesByFlat: [],
    unpaidInvoicesByFlatLoading: false,
    unpaidInvoicesByFlatError: null,

    // Create
    createLoading: false,
    createError: null,

    // Update
    updateLoading: false,
    updateError: null,

    // Delete
    deleteLoading: false,
    deleteError: null,

    // Void
    voidLoading: false,
    voidError: null,

    // Post
    postLoading: false,
    postError: null,

    // Arrears by Flat
    arrearsByFlat: null,
    arrearsLoading: false,
    arrearsError: null,

    // Bulk Operations
    bulkDetailsData: null,
    bulkDetailsLoading: false,
    bulkDetailsError: null,

    bulkPostLoading: false,
    bulkPostError: null,
    bulkPostResult: null,

    bulkDeleteLoading: false,
    bulkDeleteError: null,
    bulkDeleteResult: null,

    // Bulk Preview
    bulkPreviewLoading: false,
    bulkPreviewError: null,
    bulkPreviewResult: null,

    // Bulk Create
    bulkCreateLoading: false,
    bulkCreateError: null,
    bulkCreateResult: null
}

export function InvoiceReducer(state = initialState, action) {
    switch (action.type) {
        // Get Invoices
        case type.GET_INVOICES:
            return {
                ...state,
                loading: true,
                error: null
            }
        case type.GET_INVOICES_SUCCESS:
            return {
                ...state,
                loading: false,
                invoicesData: action.payload?.data || [],
                invoicesPagination: action.payload?.meta?.pagination || null,
                error: null
            }
        case type.GET_INVOICES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action?.message || 'Failed to fetch invoices'
            }

        // Get Invoice Details
        case type.GET_INVOICE_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                detailsError: null
            }
        case type.GET_INVOICE_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                invoiceDetails: action.payload?.data || null,
                detailsError: null
            }
        case type.GET_INVOICE_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                detailsError: action?.message || 'Failed to fetch invoice details'
            }

        // Get Invoice Statistics
        case type.GET_INVOICE_STATISTICS:
            return {
                ...state,
                statisticsLoading: true,
                statisticsError: null
            }
        case type.GET_INVOICE_STATISTICS_SUCCESS:
            return {
                ...state,
                statisticsLoading: false,
                statistics: action.payload?.data || null,
                statisticsError: null
            }
        case type.GET_INVOICE_STATISTICS_FAILURE:
            return {
                ...state,
                statisticsLoading: false,
                statisticsError: action?.message || 'Failed to fetch statistics'
            }

        // Get Invoices by Flat
        case type.GET_INVOICES_BY_FLAT:
            return {
                ...state,
                invoicesByFlatLoading: true,
                invoicesByFlatError: null
            }
        case type.GET_INVOICES_BY_FLAT_SUCCESS:
            return {
                ...state,
                invoicesByFlatLoading: false,
                invoicesByFlat: action.payload?.data || [],
                invoicesByFlatError: null
            }
        case type.GET_INVOICES_BY_FLAT_FAILURE:
            return {
                ...state,
                invoicesByFlatLoading: false,
                invoicesByFlatError: action?.message || 'Failed to fetch invoices by flat'
            }

        // Get Unpaid Invoices by Flat
        case type.GET_UNPAID_INVOICES_BY_FLAT:
            return {
                ...state,
                unpaidInvoicesByFlatLoading: true,
                unpaidInvoicesByFlatError: null
            }
        case type.GET_UNPAID_INVOICES_BY_FLAT_SUCCESS:
            return {
                ...state,
                unpaidInvoicesByFlatLoading: false,
                unpaidInvoicesByFlat: action.payload?.data || [],
                unpaidInvoicesByFlatError: null
            }
        case type.GET_UNPAID_INVOICES_BY_FLAT_FAILURE:
            return {
                ...state,
                unpaidInvoicesByFlatLoading: false,
                unpaidInvoicesByFlatError: action?.message || 'Failed to fetch unpaid invoices'
            }

        // Create Invoice
        case type.CREATE_INVOICE:
            return {
                ...state,
                createLoading: true,
                createError: null
            }
        case type.CREATE_INVOICE_SUCCESS:
            return {
                ...state,
                createLoading: false,
                createError: null
            }
        case type.CREATE_INVOICE_FAILURE:
            return {
                ...state,
                createLoading: false,
                createError: action?.message || 'Failed to create invoice'
            }

        // Update Invoice
        case type.UPDATE_INVOICE:
            return {
                ...state,
                updateLoading: true,
                updateError: null
            }
        case type.UPDATE_INVOICE_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateError: null
            }
        case type.UPDATE_INVOICE_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action?.message || 'Failed to update invoice'
            }

        // Update Draft Invoice
        case type.UPDATE_DRAFT_INVOICE:
            return {
                ...state,
                updateLoading: true,
                updateError: null
            }
        case type.UPDATE_DRAFT_INVOICE_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateError: null
            }
        case type.UPDATE_DRAFT_INVOICE_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action?.message || 'Failed to update draft invoice'
            }

        // Delete Invoice
        case type.DELETE_INVOICE:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null
            }
        case type.DELETE_INVOICE_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                deleteError: null
            }
        case type.DELETE_INVOICE_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action?.message || 'Failed to delete invoice'
            }

        // Void Invoice
        case type.VOID_INVOICE:
            return {
                ...state,
                voidLoading: true,
                voidError: null
            }
        case type.VOID_INVOICE_SUCCESS:
            return {
                ...state,
                voidLoading: false,
                voidError: null
            }
        case type.VOID_INVOICE_FAILURE:
            return {
                ...state,
                voidLoading: false,
                voidError: action?.message || 'Failed to void invoice'
            }

        // Post Invoice
        case type.POST_INVOICE:
            return {
                ...state,
                postLoading: true,
                postError: null
            }
        case type.POST_INVOICE_SUCCESS:
            return {
                ...state,
                postLoading: false,
                postError: null
            }
        case type.POST_INVOICE_FAILURE:
            return {
                ...state,
                postLoading: false,
                postError: action?.message || 'Failed to post invoice'
            }

        // Get Arrears by Flat
        case type.GET_ARREARS_BY_FLAT:
            return {
                ...state,
                arrearsLoading: true,
                arrearsError: null
            }
        case type.GET_ARREARS_BY_FLAT_SUCCESS:
            return {
                ...state,
                arrearsLoading: false,
                arrearsByFlat: action.payload?.data || null,
                arrearsError: null
            }
        case type.GET_ARREARS_BY_FLAT_FAILURE:
            return {
                ...state,
                arrearsLoading: false,
                arrearsError: action?.message || 'Failed to fetch arrears'
            }

        // Bulk Invoice Details
        case type.BULK_INVOICE_DETAILS:
            return {
                ...state,
                bulkDetailsLoading: true,
                bulkDetailsError: null
            }
        case type.BULK_INVOICE_DETAILS_SUCCESS:
            return {
                ...state,
                bulkDetailsLoading: false,
                bulkDetailsData: action.payload?.data || null,
                bulkDetailsError: null
            }
        case type.BULK_INVOICE_DETAILS_FAILURE:
            return {
                ...state,
                bulkDetailsLoading: false,
                bulkDetailsError: action?.message || 'Failed to fetch bulk invoice details'
            }

        // Bulk Post Invoices
        case type.BULK_POST_INVOICES:
            return {
                ...state,
                bulkPostLoading: true,
                bulkPostError: null,
                bulkPostResult: null
            }
        case type.BULK_POST_INVOICES_SUCCESS:
            return {
                ...state,
                bulkPostLoading: false,
                bulkPostResult: action.payload || null,
                bulkPostError: null
            }
        case type.BULK_POST_INVOICES_FAILURE:
            return {
                ...state,
                bulkPostLoading: false,
                bulkPostError: action?.message || 'Failed to bulk post invoices'
            }

        // Bulk Delete Invoices
        case type.BULK_DELETE_INVOICES:
            return {
                ...state,
                bulkDeleteLoading: true,
                bulkDeleteError: null,
                bulkDeleteResult: null
            }
        case type.BULK_DELETE_INVOICES_SUCCESS:
            return {
                ...state,
                bulkDeleteLoading: false,
                bulkDeleteResult: action.payload || null,
                bulkDeleteError: null
            }
        case type.BULK_DELETE_INVOICES_FAILURE:
            return {
                ...state,
                bulkDeleteLoading: false,
                bulkDeleteError: action?.message || 'Failed to bulk delete invoices'
            }

        // Bulk Preview Invoices
        case type.BULK_PREVIEW_INVOICES:
            return {
                ...state,
                bulkPreviewLoading: true,
                bulkPreviewError: null,
                bulkPreviewResult: null
            }
        case type.BULK_PREVIEW_INVOICES_SUCCESS:
            return {
                ...state,
                bulkPreviewLoading: false,
                bulkPreviewResult: action.payload || null,
                bulkPreviewError: null
            }
        case type.BULK_PREVIEW_INVOICES_FAILURE:
            return {
                ...state,
                bulkPreviewLoading: false,
                bulkPreviewError: action?.message || 'Failed to preview invoices'
            }

        // Bulk Create Invoices
        case type.BULK_CREATE_INVOICES:
            return {
                ...state,
                bulkCreateLoading: true,
                bulkCreateError: null,
                bulkCreateResult: null
            }
        case type.BULK_CREATE_INVOICES_SUCCESS:
            return {
                ...state,
                bulkCreateLoading: false,
                bulkCreateResult: action.payload || null,
                bulkCreateError: null
            }
        case type.BULK_CREATE_INVOICES_FAILURE:
            return {
                ...state,
                bulkCreateLoading: false,
                bulkCreateError: action?.message || 'Failed to bulk create invoices'
            }

        // Clear State
        case type.CLEAR_INVOICE_STATE:
            return initialState

        default:
            return state
    }
}
